<div class="document-container">
    <!-- Page 1 -->
    <div class="page">
        <div class="page-number">1</div>
        <h1>Confirmation Form: Agent Representation</h1>
        <p class="intro-text">This form confirms to Leeds Trinity University the relationship between the applicant and the agent, and provides consent for the agent to communicate with the university on the applicant's behalf. Please sign overleaf and return to <a href="mailto:admissions@leedstrinity.ac.uk">admissions{{this.emailComponent}}leedstrinity.ac.uk</a></p>
        
        <div class="section">
            <div class="section-heading">Applicant Information Notice:</div>
            
            <div class="section-heading">What data will be collected</div>
            <p>Data shared between Leeds Trinity University and your Agent may include your name, date of birth, academic qualifications, employment status, birth certificate, passport, immigration history and financial documents (required if a CAS/visa application is relevant). Only data required for the process of University admission will be required or shared.</p>
            
            <div class="section-heading">What your data will be used for</div>
            <p>Any data you or your Agent provides will be used to process your application to Leeds Trinity University. Your information will not be used for any other purpose.</p>
            
            <div class="section-heading">Data Controller and collection</div>
            <p>The organisation responsible for looking after your personal data (Data Controller) is Leeds Trinity University. Whilst the University may share your data with the Agent, it will control who is given access to that data with due care.</p>
            <p>You and your Agent will be responsible for collecting data and passing it on to Leeds Trinity University.</p>
            
            <div class="section-heading">Data Protection Officer</div>
            <p>Leeds Trinity University employs a full time Data Protection Officer, and if you have any queries concerning the use of your data we will be happy to receive your queries at <a href="mailto:hello@leedstrinity.ac.uk">hello{{this.emailComponent}}leedstrinity.ac.uk</a>.</p>
            <p>If you are not happy with the way your data is being handled, you have the right to complain to the Information Commissioner's Office.</p>
            
            <div class="section-heading">Sharing your data</div>
            <p>Your data will be shared with the Agent and Leeds Trinity University's recruitment and admissions teams. As per your consent on p. 2, should there be further sharing of your data this will namely only occur where the university appoints an In Country Representative (ICR) in your country/territory. An ICR may be sourced by and potentially identified as being from a separate company, but will act exclusively on behalf of the university in assisting Agents in the given territory, will be strictly bound to the same data sharing agreement as any Agent, and will be able to use data only for the same legitimate purposes outlined elsewhere in this statement.</p>
            
            <div class="section-heading">How long we will keep your data for</div>
            <p>Your personal data (in so far as it identifies you as an individual) will be stored for as long as necessary in order to assist you with your application to the University and in line with the university's statutory obligations.</p>
            
            <div class="section-heading">You have the right to:</div>
            <div class="rights-section">
                <div class="rights-column">
                    <ul>
                        <li><strong>Access</strong> – to access your personal data that we process.</li>
                        <li><strong>Rectification</strong> – that any mistakes in the data held about you are corrected.</li>
                        <li><strong>Erasure</strong> – that data held about you is deleted.</li>
                        <li><strong>Restriction of rights to process</strong> – that you limit how the data about you is used.</li>
                    </ul>
                </div>
                <div class="rights-column">
                    <ul>
                        <li><strong>Object</strong> to your data being processed.</li>
                        <li><strong>Portability</strong> – for you to have your data given back to you in an accessible form so you can take it somewhere else.</li>
                        <li><strong>Withdraw</strong> – the right to decide you do not want to continue your application to the University, but you may be happy for us to keep the data you have already provided.</li>
                    </ul>
                </div>
            </div>
            
            <p class="further-info">Further information the University's data protection policy is available in the link below. Please note that this policy is subject to occasional updates, and that this and other relevant policies are publicly available:<br>
            <a href="https://www.leedstrinity.ac.uk/media/site-assets/documents/key-documents/pdfs/data-protection-policy.pdf">https://www.leedstrinity.ac.uk/media/site-assets/documents/key-documents/pdfs/data-protection-policy.pdf</a></p>
        </div>
    </div>
    
    <!-- Page 2 -->
    <div class="page">
        <div class="page-number">2</div>
        
        <div class="applicant-section">
            <h1>To Be Filled Out by the Applicant:</h1>
            <p><em>Read each statement carefully, and tick the box next to statements where you agree</em></p>
            
            <table class="consent-table">
                <tr>
                    <td>
                        <strong>I confirm</strong> I either have applied or am interested in applying to Leeds Trinity University and am receiving advice and assistance from 
                    </td>
                    <td class="check-column">
                        <div class="checkbox-container">
                            <input type="checkbox" id="confirm" checked>
                        </div>
                        <div style="text-align:center; font-size:12px; margin-top:5px;">tick each box<br>as appropriate</div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>I consent</strong> for the Agent to act on my behalf, including submitting applications, communicating directly with the university if needed, and the signing of relevant declarations as required, with the assistance of a contracted and compliant ICR if relevant in my country/territory.
                    </td>
                    <td class="check-column">
                        <div class="checkbox-container">
                            <input type="checkbox" id="consent1" checked>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        If Leeds Trinity University provide me with an offer(s) of study, which I confirm I would like to accept, <strong>I consent</strong> for the Agent to accept this offer of study in writing on my behalf. I understand that accepting an offer of study will enter me into a Student Contract with the University.
                    </td>
                    <td class="check-column">
                        <div class="checkbox-container">
                            <input type="checkbox" id="consent2" checked>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>I consent</strong> for the Agent to be copied in to communications between the University and myself.
                    </td>
                    <td class="check-column">
                        <div class="checkbox-container">
                            <input type="checkbox" id="consent3" checked>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>I have read and understand</strong> the contents of this form and hereby agree for the sharing of my application and personal details (including financial documents when required) between the Agent and Leeds Trinity University, for the purposes of admission to the University and to assist in any CAS/visa application (if relevant).
                    </td>
                    <td class="check-column">
                        <div class="checkbox-container">
                            <input type="checkbox" id="consent4" checked>
                        </div>
                    </td>
                </tr>
            </table>
            
            <div class="form-field">
                <strong>Relevant branch address of agent:</strong>
            </div>          
            <div class="form-field">
                <strong>Applicant full name (capital letters):</strong><span>{{fullName}}</span>
            </div>
            <div class="form-field">
                <strong>Applicant/Student ID number (if known):</strong>
            </div>
            <div class="form-field">
                <strong>Applicant email:</strong><span>{{email}}</span>
            </div>
            <div class="button-container">
                <button class="submit-button" (click)="sendForSignature()">Send for signature</button>
            </div>
        </div>
    </div>

</div>


